module.exports = __webpack_public_path__ + "img/Day3_final_lazy.3f05d656.jpg";